export default __webpack_public_path__ + "static/media/CNo.40-1.29ed43d1.jpg";